import { render, staticRenderFns } from "./BannerSmallEdit.vue?vue&type=template&id=6257c1f6&"
import script from "./BannerSmallEdit.vue?vue&type=script&lang=js&"
export * from "./BannerSmallEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports